// setup simple zero-conf components
import input from "../components/input";
import { $$, closest } from "../util/dom";

$$("input, select, textarea")
    .forEach((el) => input(el, { target: closest(el, ".form-group") }));
